import React, {createContext, useContext} from 'react'
import {DataObjectId} from 'yougile-model'

export interface ContextTaskContextProps {
  taskId?: DataObjectId
}

const ContextTaskContext = createContext<ContextTaskContextProps>({
  taskId: undefined
})

/**
 * Context task provider should be added to the root of every component that works with specific task. It provides taskId to all children components and can be used by shared components in the platform.
 * @param taskId
 * @param children
 * @constructor
 */
export const ContextTaskProvider = ({
  taskId,
  children
}: {
  taskId?: DataObjectId
  children: React.ReactNode
}) => {
  return (
    <ContextTaskContext.Provider value={{taskId}}>
      {children}
    </ContextTaskContext.Provider>
  )
}

export const useContextTask = (): ContextTaskContextProps => {
  return useContext(ContextTaskContext)
}
